import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackShareWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackShareWishList = (parameters: TrackShareWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "share_wishlist", ...parameters }, options);
};

export default trackShareWishList;
